<template>
  <div class="pt-5" v-if="currentLanguage == 'en'" style="background-color: #F6F9FB;">
    <section class="pb-5">
      <div class="section-title text-center mb-5">
        <h1>Free Background Remover Online</h1>
        <p>Remove backgrounds from your images automatically in seconds</p>
      </div>
      <div class="tool">
        <background-removal></background-removal>
      </div>
    </section>

    <section class="help-section">
      <div class="help-header text-center">
        <h2 class="help-title">Background Remover Guide and FAQs</h2>
        <p class="help-subtitle">Learn about SplendApp's Background Removal tool</p>
      </div>

      <nav class="tabs-nav" role="tablist" aria-label="Help topics">
        <button type="button" role="tab" id="background-removal-en-faq-tab" aria-controls="background-removal-en-faq-panel" :aria-selected="activeTab === 'faq'" :class="['tab-btn', activeTab === 'faq' ? 'active' : '']" @click="activeTab = 'faq'" @keydown.right.prevent="activeTab = 'guide'">
          Frequently Asked Questions
        </button>
        <button type="button" role="tab" id="background-removal-en-guide-tab" aria-controls="background-removal-en-guide-panel" :aria-selected="activeTab === 'guide'" :class="['tab-btn', activeTab === 'guide' ? 'active' : '']" @click="activeTab = 'guide'" @keydown.left.prevent="activeTab = 'faq'">
          Usage Guide
        </button>
      </nav>

      <div v-show="activeTab === 'faq'" id="background-removal-en-faq-panel" role="tabpanel" aria-labelledby="background-removal-en-faq-tab" class="tab-pane">
        <div class="section-label">
          <span class="label-icon">⚙️</span> Technical Questions
        </div>
        <div
          v-for="(item, i) in enFaqTechnical"
          :key="'t'+i"
          class="faq-item"
          :class="{ open: openFaq === 'en-t-'+i }"
        >
          <div class="faq-question" @click="openFaq = openFaq === 'en-t-'+i ? null : 'en-t-'+i">
            {{ item.q }}
            <span class="faq-toggle">{{ openFaq === 'en-t-'+i ? '−' : '+' }}</span>
          </div>
          <div class="faq-answer">{{ item.a }}</div>
        </div>

        <div class="section-label">
          <span class="label-icon">📱</span> Usage & Customization
        </div>
        <div
          v-for="(item, i) in enFaqUsage"
          :key="'u'+i"
          class="faq-item"
          :class="{ open: openFaq === 'en-u-'+i }"
        >
          <div class="faq-question" @click="openFaq = openFaq === 'en-u-'+i ? null : 'en-u-'+i">
            {{ item.q }}
            <span class="faq-toggle">{{ openFaq === 'en-u-'+i ? '−' : '+' }}</span>
          </div>
          <div class="faq-answer">{{ item.a }}</div>
        </div>

        <div class="section-label">
          <span class="label-icon">⚖️</span> Privacy & Rights
        </div>
        <div
          v-for="(item, i) in enFaqRights"
          :key="'r'+i"
          class="faq-item"
          :class="{ open: openFaq === 'en-r-'+i }"
        >
          <div class="faq-question" @click="openFaq = openFaq === 'en-r-'+i ? null : 'en-r-'+i">
            {{ item.q }}
            <span class="faq-toggle">{{ openFaq === 'en-r-'+i ? '−' : '+' }}</span>
          </div>
          <div class="faq-answer">{{ item.a }}</div>
        </div>
      </div>

      <div v-show="activeTab === 'guide'" id="background-removal-en-guide-panel" role="tabpanel" aria-labelledby="background-removal-en-guide-tab" class="tab-pane">
        <div class="search-box">
          <input
            type="text"
            v-model="guideSearch"
            placeholder="Search the usage guide..."
          >
          <span class="search-icon">🔍</span>
        </div>
        <div id="guideContent">
          <div v-for="(step, i) in filteredStepsEn" :key="i" class="step-card">
            <h3>{{ i + 1 }}. {{ step.title }}</h3>
            <p>{{ step.desc }}</p>
            <div class="snippet-placeholder">{{ step.placeholder }}</div>
          </div>
        </div>
        <p v-if="filteredStepsEn.length === 0" class="no-results">Sorry, no results found.</p>
      </div>
    </section>
  </div>

  <div class="pt-5" style="direction: rtl; background-color: #F6F9FB;" v-else-if="currentLanguage == 'ar'">
    <section class="pb-5">
      <div class="section-title text-center mb-5">
        <h1>إزالة خلفية الصورة أونلاين</h1>
        <p>أزل خلفية الصور تلقائياً في ثوانٍ معدودة وباحترافية عالية</p>
      </div>
      <div class="tool">
        <background-removal></background-removal>
      </div>
    </section>

    <section class="help-section">
      <div class="help-header text-center">
        <h2 class="help-title">دليل إزالة الخلفية والأسئلة الشائعة</h2>
        <p class="help-subtitle">تعرف على أداة إزالة الخلفية من سبلينداب</p>
      </div>

      <nav class="tabs-nav" role="tablist" aria-label="موضوعات المساعدة">
        <button type="button" role="tab" id="background-removal-ar-faq-tab" aria-controls="background-removal-ar-faq-panel" :aria-selected="activeTab === 'faq'" :class="['tab-btn', activeTab === 'faq' ? 'active' : '']" @click="activeTab = 'faq'" @keydown.right.prevent="activeTab = 'guide'">
          الأسئلة الشائعة
        </button>
        <button type="button" role="tab" id="background-removal-ar-guide-tab" aria-controls="background-removal-ar-guide-panel" :aria-selected="activeTab === 'guide'" :class="['tab-btn', activeTab === 'guide' ? 'active' : '']" @click="activeTab = 'guide'" @keydown.left.prevent="activeTab = 'faq'">
          دليل الاستخدام
        </button>
      </nav>

      <div v-show="activeTab === 'faq'" id="background-removal-ar-faq-panel" role="tabpanel" aria-labelledby="background-removal-ar-faq-tab" class="tab-pane">
        <div class="section-label">
          <span class="label-icon">⚙️</span> أسئلة تقنية
        </div>
        <div
          v-for="(item, i) in arFaqTechnical"
          :key="'art'+i"
          class="faq-item"
          :class="{ open: openFaq === 'ar-t-'+i }"
        >
          <div class="faq-question" @click="openFaq = openFaq === 'ar-t-'+i ? null : 'ar-t-'+i">
            {{ item.q }}
            <span class="faq-toggle">{{ openFaq === 'ar-t-'+i ? '−' : '+' }}</span>
          </div>
          <div class="faq-answer">{{ item.a }}</div>
        </div>

        <div class="section-label">
          <span class="label-icon">📱</span> الاستخدام والتعديل
        </div>
        <div
          v-for="(item, i) in arFaqUsage"
          :key="'aru'+i"
          class="faq-item"
          :class="{ open: openFaq === 'ar-u-'+i }"
        >
          <div class="faq-question" @click="openFaq = openFaq === 'ar-u-'+i ? null : 'ar-u-'+i">
            {{ item.q }}
            <span class="faq-toggle">{{ openFaq === 'ar-u-'+i ? '−' : '+' }}</span>
          </div>
          <div class="faq-answer">{{ item.a }}</div>
        </div>

        <div class="section-label">
          <span class="label-icon">⚖️</span> الخصوصية والحقوق
        </div>
        <div
          v-for="(item, i) in arFaqRights"
          :key="'arr'+i"
          class="faq-item"
          :class="{ open: openFaq === 'ar-r-'+i }"
        >
          <div class="faq-question" @click="openFaq = openFaq === 'ar-r-'+i ? null : 'ar-r-'+i">
            {{ item.q }}
            <span class="faq-toggle">{{ openFaq === 'ar-r-'+i ? '−' : '+' }}</span>
          </div>
          <div class="faq-answer">{{ item.a }}</div>
        </div>
      </div>

      <div v-show="activeTab === 'guide'" id="background-removal-ar-guide-panel" role="tabpanel" aria-labelledby="background-removal-ar-guide-tab" class="tab-pane">
        <div class="search-box">
          <input
            type="text"
            v-model="guideSearch"
            placeholder="ابحث في دليل الاستخدام..."
          >
          <span class="search-icon">🔍</span>
        </div>
        <div>
          <div v-for="(step, i) in filteredStepsAr" :key="i" class="step-card">
            <h3>{{ i + 1 }}. {{ step.title }}</h3>
            <p>{{ step.desc }}</p>
            <div class="snippet-placeholder">{{ step.placeholder }}</div>
          </div>
        </div>
        <p v-if="filteredStepsAr.length === 0" class="no-results">عذراً، لم نجد نتائج تطابق بحثك.</p>
      </div>
    </section>
  </div>
</template>

<script>
import BackgroundRemoval from '@/components/BackgroundremovalCom.vue'
import ToolsComen from '@/components/ToolsComen.vue';
import ToolsComar from '@/components/ToolsComar.vue';

export default {
  name: 'BackgroundRemoverPage',
  components: { BackgroundRemoval, ToolsComen, ToolsComar },
  data() {
    return {
      currentLanguage: this.$store.state.currentLanguage,
      title: '',
      description: '',
      activeTab: 'faq',
      openFaq: null,
      guideSearch: '',

      // ─── Arabic FAQ Data ───────────────────────────────────────
      arFaqTechnical: [
        {
          q: 'كيف تعمل الأداة على إزالة الخلفية؟',
          a: 'تعتمد الأداة على تقنيات الذكاء الاصطناعي المتقدمة لتحليل الصورة، والتعرف على العنصر الأساسي (مثل الأشخاص أو المنتجات)، وفصله عن الخلفية بدقة واحترافية في ثوانٍ.'
        },
        {
          q: 'ما هي صيغ الصور المدعومة للرفع؟',
          a: 'الأداة تدعم رفع الصور بصيغ JPG و PNG و WebP. تأكد من أن حجم الصورة لا يتجاوز 20 ميجابايت للحصول على أفضل أداء.'
        },
        {
          q: 'كيف يمكنني الحفاظ على شفافية الصورة عند التحميل؟',
          a: 'للحفاظ على خلفية شفافة، تأكد من تحديد اللون "شفاف" من لوحة الألوان، ثم اختر صيغة التصدير PNG، لأن صيغة JPG لا تدعم الشفافية.'
        }
      ],
      arFaqUsage: [
        {
          q: 'هل يمكنني تغيير لون الخلفية بعد إزالتها؟',
          a: 'نعم، بمجرد إزالة الخلفية، ستظهر لك لوحة ألوان. يمكنك اختيار خلفية شفافة، بيضاء، رمادية، أو استخدام أداة "اللون المخصص" لاختيار أي لون يتناسب مع هويتك التجارية.'
        },
        {
          q: 'هل الأداة تعمل على الهواتف الذكية؟',
          a: 'بالتأكيد. الأداة مصممة لتعمل بسلاسة على جميع الأجهزة، بما في ذلك أجهزة الآيفون والأندرويد، عبر متصفح الويب المفضل لديك.'
        },
        {
          q: 'ما هي أفضل صيغة تصدير للمتاجر الإلكترونية؟',
          a: 'ننصح بصيغة WebP إذا كنت ترغب في الحفاظ على سرعة تحميل متجرك مع جودة عالية، أو بصيغة PNG إذا كان منتجك يحتاج إلى خلفية شفافة لعرضه فوق تصاميم أخرى.'
        }
      ],
      arFaqRights: [
        {
          q: 'هل صوري آمنة ويتم حفظها على خوادمكم؟',
          a: 'صُورك في أمان تام! الأداة تعمل محلياً (Local) داخل متصفحك. نحن لا نقوم برفع أو حفظ أو تخزين صورك على أي خوادم خارجية.'
        },
        {
          q: 'هل توجد علامة مائية (Watermark) على الصورة النهائية؟',
          a: 'لا، الأداة مقدمة مجاناً لدعم أصحاب المشاريع. الصور الناتجة خالية تماماً من العلامات المائية وتكون جاهزة للاستخدام الاحترافي فوراً.'
        }
      ],

      // ─── Arabic Guide Steps ────────────────────────────────────
      arGuideSteps: [
        {
          title: 'رفع الصورة',
          desc: 'قم بسحب وإفلات الصورة داخل المربع المخصص، أو اضغط على "اختر صورة" لتصفح ملفات جهازك.',
          placeholder: '[تلميح: تأكد من أن العنصر الأساسي في الصورة واضح ومضاء جيداً لنتائج أفضل]',
          keywords: 'رفع الصور اختيار ملفات تحميل'
        },
        {
          title: 'إزالة الخلفية الذكية',
          desc: 'بمجرد رفع الصورة، سيبدأ الذكاء الاصطناعي بمعالجتها تلقائياً. سترى نسبة التقدم في المنتصف.',
          placeholder: '[تلميح: تستغرق العملية عادة من 3 إلى 5 ثوانٍ فقط]',
          keywords: 'معالجة ذكاء اصطناعي إزالة'
        },
        {
          title: 'تخصيص لون الخلفية',
          desc: 'من لوحة الإعدادات، اختر لوناً جديداً للخلفية (أبيض، ملون) أو اتركها شفافة لتناسب تصاميمك.',
          placeholder: '[تلميح: للمنتجات، الخلفية البيضاء أو الشفافة هي الخيار الأفضل دائماً]',
          keywords: 'تلوين خلفية شفاف ألوان تخصيص'
        },
        {
          title: 'التصدير والتحميل',
          desc: 'اختر الصيغة المناسبة (PNG للشفافية، WebP للأداء) ثم اضغط "تحميل الصورة النهائية" لحفظها.',
          placeholder: '[تلميح: يتم حفظ الصورة مباشرة في مجلد التنزيلات بجهازك]',
          keywords: 'تحميل حفظ تصدير نهائي صيغة'
        }
      ],

      // ─── English FAQ Data ──────────────────────────────────────
      enFaqTechnical: [
        {
          q: 'How does the background removal AI work?',
          a: 'Our tool uses advanced machine learning models to analyze your image, detect the main subject (like a person or product), and separate it from the background with high precision in seconds.'
        },
        {
          q: 'What image formats can I upload?',
          a: 'You can upload JPG, PNG, and WebP files. For the best processing speed, we recommend keeping your file sizes under 20MB.'
        },
        {
          q: 'How do I make sure my background stays transparent?',
          a: 'To keep a transparent background, select "Transparent" from the color palette, and ensure you export the final image as a PNG, since JPGs do not support alpha/transparency channels.'
        }
      ],
      enFaqUsage: [
        {
          q: 'Can I add a solid color background instead of transparent?',
          a: 'Yes! Once the background is removed, a color palette will appear. You can choose transparent, white, gray, or use the custom color picker to match your brand identity.'
        },
        {
          q: 'Does this work on mobile devices?',
          a: 'Absolutely. The tool is fully responsive and works smoothly on smartphones and tablets directly through your mobile browser.'
        },
        {
          q: 'Which export format is best for eCommerce?',
          a: 'We recommend WebP for fast website loading speeds, or PNG if you need the product to have a transparent background so it can seamlessly blend into your store design.'
        }
      ],
      enFaqRights: [
        {
          q: 'Are my images safe? Do you store them?',
          a: 'Your images are 100% private. All AI processing happens locally in your web browser. We never upload, save, or store your images on external servers.'
        },
        {
          q: 'Will there be a watermark on my downloaded image?',
          a: 'No watermarks! We built this tool to help creators and business owners. The final images are completely clean and ready for professional use.'
        }
      ],

      // ─── English Guide Steps ───────────────────────────────────
      enGuideSteps: [
        {
          title: 'Upload Your Image',
          desc: 'Drag and drop your image into the drop zone, or click the "Choose File" button to browse your device.',
          placeholder: '[Tip: Images with good lighting and clear subjects yield the best results]',
          keywords: 'upload images select files drag drop'
        },
        {
          title: 'Smart AI Processing',
          desc: 'Once uploaded, the AI instantly starts removing the background. You will see a progress percentage in the middle.',
          placeholder: '[Tip: Processing typically takes just 3 to 5 seconds]',
          keywords: 'processing ai remove wait'
        },
        {
          title: 'Customize the Background',
          desc: 'Use the settings panel to pick a solid background color (like white for eCommerce) or leave it completely transparent.',
          placeholder: '[Tip: Use the custom color picker to match your brand guidelines]',
          keywords: 'color background transparent customize'
        },
        {
          title: 'Export and Download',
          desc: 'Select your preferred format (PNG for transparency, WebP for web performance) and hit "Download Final Image".',
          placeholder: '[Tip: The image will save directly to your default downloads folder]',
          keywords: 'download save export format'
        }
      ]
    }
  },

  computed: {
    filteredStepsAr() {
      if (!this.guideSearch) return this.arGuideSteps;
      const q = this.guideSearch.toLowerCase();
      return this.arGuideSteps.filter(s =>
        (s.title + s.desc + s.keywords).toLowerCase().includes(q)
      );
    },
    filteredStepsEn() {
      if (!this.guideSearch) return this.enGuideSteps;
      const q = this.guideSearch.toLowerCase();
      return this.enGuideSteps.filter(s =>
        (s.title + s.desc + s.keywords).toLowerCase().includes(q)
      );
    }
  },

  watch: {
    '$store.state.currentLanguage': function (newLanguage) {
      this.currentLanguage = newLanguage;
      this.openFaq = null;
      this.guideSearch = '';
      if (this.currentLanguage == 'en') {
        this.$router.push({ name: 'background-removal-en' });
      } else {
        this.$router.push({ name: 'background-removal-ar' });
      }
    }
  }
}
</script>

<style scoped lang='scss'>
p {
  font-size: 14px;
  color: #716c80;
}

.section-title {
  h2 {
    line-height: 1.4;
    margin-bottom: 0;
    font-size: 36px;
    font-weight: 700;
    color: #262A37;
  }
  p {
    font-size: 21px;
    color: #716c80;
    margin-bottom: 15px;
  }
}

// ── Help Section ─────────────────────────────────────────────────
.help-section {
  max-width: 900px;
  margin: 30px auto;
  margin-bottom: 0 ;
  padding: 20px;
  font-family: 'Cairo', sans-serif;
}

.help-header {
  margin-bottom: 40px;
}

.help-title {
  font-weight: 800;
  font-size: 2rem;
  color: #1e1b4b;
  margin-bottom: 8px;
}

.help-subtitle {
  color: #64748b;
  font-size: 14px;
}

// ── Tabs ──────────────────────────────────────────────────────────
.tabs-nav {
  display: flex;
  background: white;
  border-radius: 15px;
  overflow: hidden;
  margin-bottom: 25px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}

.tab-btn {
  flex: 1;
  padding: 18px;
  border: none;
  background: none;
  font-family: 'Cairo', sans-serif;
  font-weight: 700;
  cursor: pointer;
  transition: 0.3s;
  font-size: 1rem;
  color: #64748b;
  border-bottom: 3px solid transparent;

  &.active {
    color: #3a7afe;
    background: #fdfdff;
    border-bottom: 3px solid #3a7afe;
  }
}

.tab-pane {
  animation: fadeIn 0.4s ease;
}

// ── Section Labels ────────────────────────────────────────────────
.section-label {
  font-size: 1rem;
  font-weight: 700;
  color: #3a7afe;
  margin: 25px 0 15px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e2e8f0;

  .label-icon {
    margin-left: 6px;
    margin-right: 6px;
  }
}

// ── FAQ Items ─────────────────────────────────────────────────────
.faq-item {
  background: white;
  border-radius: 15px;
  margin-bottom: 12px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
}

.faq-question {
  padding: 18px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  color: #1e1b4b;
  font-size: 14px;
  transition: color 0.3s;

  .faq-toggle {
    font-size: 20px;
    color: #64748b;
    flex-shrink: 0;
    margin-right: 8px;
    margin-left: 8px;
    line-height: 1;
  }
}

.faq-answer {
  padding: 0 18px;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-out, padding 0.3s;
  color: #64748b;
  font-size: 14px;
  line-height: 1.7;
}

.faq-item.open {
  .faq-question {
    color: #3a7afe;
  }
  .faq-answer {
    max-height: 300px;
    padding: 0 18px 18px;
  }
}

// ── Search Box ────────────────────────────────────────────────────
.search-box {
  position: relative;
  margin-bottom: 30px;

  input {
    width: 100%;
    padding: 15px 45px 15px 20px;
    border-radius: 12px;
    border: 2px solid #e2e8f0;
    font-family: 'Cairo', sans-serif;
    font-size: 1rem;
    box-sizing: border-box;
    outline: none;
    transition: 0.3s;
    color: #1e1b4b;

    &:focus {
      border-color: #3a7afe;
      box-shadow: 0 0 10px rgba(99, 102, 241, 0.1);
    }

    &::placeholder {
      color: #94a3b8;
    }
  }

  .search-icon {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 1.1rem;
    pointer-events: none;
  }
}

// ── Step Cards ────────────────────────────────────────────────────
.step-card {
  background: white;
  padding: 25px;
  border-radius: 20px;
  margin-bottom: 20px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.02);
  border-right: 5px solid #3a7afe;

  h2 {
    margin-top: 0;
    font-size: 1.2rem;
    color: #3a7afe;
    font-weight: 700;
    margin-bottom: 10px;
  }

  p {
    margin-bottom: 0;
    color: #64748b;
    font-size: 14px;
    line-height: 1.7;
  }
}

.snippet-placeholder {
  background: #f1f5f9;
  border: 2px dashed #cbd5e1;
  border-radius: 12px;
  padding: 30px;
  text-align: center;
  margin: 15px 0 0;
  color: #94a3b8;
  font-size: 13px;
  display: none;
}

// ── No Results ────────────────────────────────────────────────────
.no-results {
  text-align: center;
  padding: 40px;
  color: #64748b;
  font-size: 14px;
}

// ── Animations ───────────────────────────────────────────────────
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to   { opacity: 1; transform: translateY(0); }
}

// ── Existing styles ───────────────────────────────────────────────
.image {
  img { width: 100%; }
  max-width: 100%;
}

section .row { margin-top: 100px; }

.intro-video-content h2 {
  line-height: 1.4;
  color: #24365c;
  font-size: 48px;
  margin-bottom: 15px;
  font-weight: 700;
}

iframe {
  height: 400px;
  width: 100%;
  border-radius: 10px;
}

.single-features-item {
  background-color: white;
  transition: .5s;
  padding: 40px 30px 35px 110px;
  margin-bottom: 25px;
  border-radius: 5px;
  position: relative;
  z-index: 1;

  h3 { font-size: 20px; font-weight: 700; }

  &:hover {
    box-shadow: 0 50px 100px -20px rgba(50, 50, 93, .1), 0 30px 60px -30px rgba(107, 124, 147, .15);

    &::before { opacity: 1; visibility: visible; }
    a, h3, p { color: white; }
  }

  &::before {
    content: '';
    position: absolute;
    top: 0; left: 0;
    width: 100%; height: 100%;
    border-radius: 5px;
    background: linear-gradient(44.44deg, #3a7afe .79%, #0053fe 94.18%);
    z-index: -1;
    opacity: 0;
    visibility: hidden;
    transition: .5s;
  }
}

@media (max-width: 769px) {
  .single-features-item { padding-left: 30px; }
  .help-section { padding: 10px; }
  .tab-btn { padding: 12px; font-size: 0.9rem; }
  .step-card { padding: 15px; }
  .help-title { font-size: 1.5rem; }
}

@media (min-width: 1400px) {
  .container, .container-lg, .container-md,
  .container-sm, .container-xl, .container-xxl {
    max-width: 1140px;
  }
}
</style>
